import { Link, Navigate, useNavigate } from "react-router-dom";
import { Clock3, LogOut } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { getExpertApprovalStatus, hasApprovedExpertAccess } from "@/lib/expertAccess";

export default function ExpertApprovalPending() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const status = getExpertApprovalStatus(user);

  if (hasApprovedExpertAccess(user)) return <Navigate to="/expert" replace />;
  if (status !== "pending") return <Navigate to="/expert/onboarding" replace />;

  const handleLogout = async () => {
    await logout();
    navigate("/");
  };

  return (
    <div className="max-w-2xl mx-auto px-4 py-16">
      <div className="card-outline p-8 text-center" data-testid="expert-approval-pending">
        <div className="w-14 h-14 mx-auto rounded-full bg-brand-soft flex items-center justify-center">
          <Clock3 size={26} className="text-brand-green" aria-hidden />
        </div>
        <h1 className="mt-5 text-3xl font-bold text-brand-ink">
          Din profil afventer godkendelse
        </h1>
        <p className="mt-3 text-brand-body">
          Din ekspertprofil er sendt til godkendelse. Du får adgang til ekspertplatformen, når profilen er blevet godkendt.
        </p>
        <div className="mt-7 flex flex-col sm:flex-row justify-center gap-3">
          <Link to="/" className="btn-secondary">
            Gå til SpørgMig
          </Link>
          <button type="button" onClick={handleLogout} className="btn-primary inline-flex items-center justify-center gap-2">
            <LogOut size={16} /> Log ud
          </button>
        </div>
      </div>
    </div>
  );
}

